package ru.villawonka.app.data.entity.dto

import ru.villawonka.app.domain.model.AccommodationAdditionDomain

fun String.toAccommodationAdditionDomainOrNull(): AccommodationAdditionDomain? =
    when (this.lowercase()) {
        "near_gym" -> AccommodationAdditionDomain.NEAR_GYM
        "near_cafe" -> AccommodationAdditionDomain.NEAR_CAFE
        "near_beach" -> AccommodationAdditionDomain.NEAR_BEACH
        "tv" -> AccommodationAdditionDomain.TV
        "wifi" -> AccommodationAdditionDomain.WIFI
        "washing_machine" -> AccommodationAdditionDomain.WASHING_MACHINE
        "safe" -> AccommodationAdditionDomain.SAFE
        "jacuzzi" -> AccommodationAdditionDomain.JACUZZI
        "air_condition" -> AccommodationAdditionDomain.AIR_CONDITION
        "terrace" -> AccommodationAdditionDomain.TERRACE
        "video_surveillance" -> AccommodationAdditionDomain.VIDEO_SURVEILLANCE
        "barbecue_area" -> AccommodationAdditionDomain.BARBECUE_AREA
        "grill" -> AccommodationAdditionDomain.BARBECUE_AREA  // Альтернативное название
        "pool" -> AccommodationAdditionDomain.POOL
        "parking" -> AccommodationAdditionDomain.PARKING
        "cleaning" -> AccommodationAdditionDomain.CLEANING
        "closed_kitchen" -> AccommodationAdditionDomain.CLOSED_KITCHEN
        "closed_living_room" -> AccommodationAdditionDomain.CLOSED_LIVING_ROOM
        "utility_bills_included" -> AccommodationAdditionDomain.UTILITY_BILLS_INCLUDED
        "drink_water_included" -> AccommodationAdditionDomain.DRINK_WATER_INCLUDED
        "has_discount" -> AccommodationAdditionDomain.HAS_DISCOUNT
        else -> null  // Для неизвестных значений
    }

fun AccommodationAdditionDomain.toDtoString(): String =
    when (this) {
        AccommodationAdditionDomain.NEAR_GYM -> "near_gym"
        AccommodationAdditionDomain.NEAR_CAFE -> "near_cafe"
        AccommodationAdditionDomain.NEAR_BEACH -> "near_beach"
        AccommodationAdditionDomain.TV -> "tv"
        AccommodationAdditionDomain.WIFI -> "wifi"
        AccommodationAdditionDomain.WASHING_MACHINE -> "washing_machine"
        AccommodationAdditionDomain.SAFE -> "safe"
        AccommodationAdditionDomain.JACUZZI -> "jacuzzi"
        AccommodationAdditionDomain.AIR_CONDITION -> "air_condition"
        AccommodationAdditionDomain.TERRACE -> "terrace"
        AccommodationAdditionDomain.VIDEO_SURVEILLANCE -> "video_surveillance"
        AccommodationAdditionDomain.BARBECUE_AREA -> "barbecue_area"
        AccommodationAdditionDomain.POOL -> "pool"
        AccommodationAdditionDomain.PARKING -> "parking"
        AccommodationAdditionDomain.CLEANING -> "cleaning"
        AccommodationAdditionDomain.CLOSED_KITCHEN -> "closed_kitchen"
        AccommodationAdditionDomain.CLOSED_LIVING_ROOM -> "closed_living_room"
        AccommodationAdditionDomain.UTILITY_BILLS_INCLUDED -> "utility_bills_included"
        AccommodationAdditionDomain.DRINK_WATER_INCLUDED -> "drink_water_included"
        AccommodationAdditionDomain.HAS_DISCOUNT -> "has_discount"
    }